import { render } from "./BigPlus.svg?vue&type=template&id=0efc4410"
const script = {}
script.render = render

export default script